module.exports = __webpack_public_path__ + "img/2_3_1_1.2350ad74.png";